const ElfsightReviews = () => {
  // TEMPORARILY DISABLED: Elfsight widget hitting APP_VIEWS_LIMIT_REACHED
  // Re-enable when subscription is upgraded or view limits reset
  return null;
};

export default ElfsightReviews;
